module.exports = __webpack_public_path__ + "static/icons/icon-heart-red-08f7a5b023c2d7b89de206c5ffb06294.svg";